import React from "react";
import PropTypes from "prop-types";
import BRANDS, { getCurrentBrand } from "constants/brands";
import LEGAL_DOCUMENT_TYPES from "constants/legalDocuments";
import TermsAndConditionsContent from "./TermsAndConditionsContent";
import PrivacyPolicyContent from "./PrivacyPolicyContent";
import TalentSimpleTermsAndConditionsContent from "./TalentSimpleTermsAndConditionsContent";
import TalentSimplePrivacyPolicyContent from "./TalentSimplePrivacyPolicyContent";

const DOCUMENTS = {
  [BRANDS.missionDev]: {
    [LEGAL_DOCUMENT_TYPES.terms]: TermsAndConditionsContent,
    [LEGAL_DOCUMENT_TYPES.privacy]: PrivacyPolicyContent,
  },
  [BRANDS.talentSimple]: {
    [LEGAL_DOCUMENT_TYPES.terms]: TalentSimpleTermsAndConditionsContent,
    [LEGAL_DOCUMENT_TYPES.privacy]: TalentSimplePrivacyPolicyContent,
  },
};

/**
 * LegalDocument
 *
 * Legal document of the brand served on the current host
 *
 * @param {String}   type   One of LEGAL_DOCUMENT_TYPES
 */
const LegalDocument = ({ type, ...props }) => {
  const Document = DOCUMENTS[getCurrentBrand()][type];

  return <Document {...props} />;
};

LegalDocument.propTypes = {
  type: PropTypes.oneOf(Object.values(LEGAL_DOCUMENT_TYPES)).isRequired,
};

export default LegalDocument;
